import { Label, PopOver, Skeleton } from '../index';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Input } from 'antd';
import SliderContent from './slider-content';

const Slider = ({
  onApply = () => {},
  filtersObject = {},
  loading = false,
  minRange = 0,
  stepSize = 10,
  filterKey = '',
  label = '',
  labelSize = 'small',
  labelClassName = '',
  required = false,
  placeholder = '',
  isAdvancedFilter,
  ...item
}) => {
  const { t } = useTranslation();
  const [minValue, setMinValue] = useState(0);
  const [maxRange, setMaxRange] = useState(1000);
  const [maxValue, setMaxValue] = useState('');
  const [visible, setVisible] = useState(false);
  const [parentInputValue, setParentInputValue] = useState('');

  useEffect(() => {
    if (!filtersObject || Object.keys(filtersObject).length === 0) {
      clickOnResetButton();
    }
    const prefillMinVal = filtersObject[`f[${filterKey}][gte]`];
    const prefillMaxVal = filtersObject[`f[${filterKey}][lte]`];

    if (!prefillMaxVal && !prefillMinVal) {
      setParentInputValue('');
      setMinValue(0);
      setMaxValue('');
    }

    if (!prefillMaxVal) return;

    setParentInputValue(`${prefillMinVal ? prefillMinVal : minRange} - ${prefillMaxVal}`);
    setMinValue(prefillMinVal ? prefillMinVal : minRange);
    setMaxValue(prefillMaxVal);
  }, [filtersObject]);

  const inputChange = ({ name, value }) => {
    if (name === 'max') {
      if (value) {
        setMaxValue(parseInt(value));
      } else {
        setMaxValue(parseInt(0));
      }
      if (value > maxRange) {
        setMaxRange(parseInt(value));
      }
    } else if (!isNaN(value) && value >= minRange && value <= maxRange) {
      if (name === 'min') {
        setMinValue(value);
      }
    }
  };

  const clickOnResetButton = () => {
    setVisible(false);
    setMinValue(0);
    setMaxValue('');
    setParentInputValue('');
    onApply('', '');
  };

  const clickOnApplyButton = () => {
    const checkedMinVal = typeof minValue === 'string' ? Number(minValue) : minValue;
    const checkedMaxVal = typeof maxValue === 'string' ? Number(maxValue) : maxValue;

    const finalMinVal = checkedMinVal ? checkedMinVal : minRange;
    const finalMaxVal = checkedMaxVal ? checkedMaxVal : maxRange;

    setVisible(false);
    onApply(finalMinVal, finalMaxVal);
    setParentInputValue(`${finalMinVal} - ${finalMaxVal}`);
  };

  const handleSliderChange = (values) => {
    const minValue = values[0] || 0;
    const maxValue = values[1] || 0;
    setMinValue(minValue);
    setMaxValue(maxValue);
  };

  if (loading) return <Skeleton height={40} />;

  return (
    <div>
      {label && (
        <Label size={labelSize} className={labelClassName} required={required}>
          {label}
        </Label>
      )}
      <PopOver
        content={
          <SliderContent
            handleSliderChange={handleSliderChange}
            clickOnApplyButton={clickOnApplyButton}
            clickOnResetButton={clickOnResetButton}
            inputChange={inputChange}
            stepSize={stepSize}
            maxValue={maxValue}
            minValue={minValue}
            maxRange={maxRange}
            minRange={minRange}
            isAdvancedFilter={isAdvancedFilter}
          />
        }
        trigger={'click'}
        visible={visible}
        setVisible={setVisible}
      >
        <Input value={parentInputValue} placeholder={placeholder} readOnly={true} />
      </PopOver>
    </div>
  );
};

export default Slider;
